// roughness history: saved calibrations (date chosen by the user) -> k series per group / pipe and increase in mm per year
const yr = (d) => new Date(`${d}T12:00:00`).getTime() / (365.25 * 864e5);

export function rate(pts) {
  if (pts.length < 2) return null;
  const xs = pts.map((p) => yr(p.date)), ys = pts.map((p) => p.k), n = pts.length, mx = xs.reduce((a, b) => a + b) / n, my = ys.reduce((a, b) => a + b) / n;
  const sxx = xs.reduce((s, x) => s + (x - mx) ** 2, 0);
  return sxx < 1e-6 ? null : xs.reduce((s, x, i) => s + (x - mx) * (ys[i] - my), 0) / sxx;
}

const sorted = (h) => [...(h || [])].sort((a, b) => a.date.localeCompare(b.date));

export function groupSeries(hist) {
  const S = {};
  sorted(hist).forEach((e) => e.groups.filter((g) => !g.fixed && !g.na).forEach((g) => { (S[g.label] ||= []).push({ date: e.date, k: g.kNew, id: e.id }); }));
  return Object.entries(S).map(([label, pts]) => ({ label, pts, rate: rate(pts) }));
}

export function pipeSeries(hist, pipeId) {
  const pts = [];
  sorted(hist).forEach((e) => { const g = e.groups.find((x) => !x.fixed && !x.na && x.pipes.includes(pipeId)); if (g) pts.push({ date: e.date, k: g.kNew, label: g.label, id: e.id }); });
  return { pts, rate: rate(pts) };
}
